import { render } from "./Merchants.vue?vue&type=template&id=0b3744a8&scoped=true&ts=true"
import script from "./Merchants.vue?vue&type=script&lang=ts"
export * from "./Merchants.vue?vue&type=script&lang=ts"

import "./Merchants.vue?vue&type=style&index=0&id=0b3744a8&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3744a8"]])

export default __exports__